module.exports = __webpack_public_path__ + "img/account_image_cdkey_ch@2x.26a6636a.png";